import React, { useCallback, useEffect, useMemo, useRef } from 'react';
import moment from 'moment';
// Types
import { ProductionPackSiteProps } from 'types/productionPackSite';

// Utils
import { useSetState } from 'utils';
import { getPackSiteCellData } from 'utils/packSite';
// Assets
import Icon from 'assets/Icon';
// Elements
import Button from 'elements/Button';
import ListCell from 'elements/ListCell';
// Styles
import styles from './style/packsites.module.css';
import PackSiteModal from './PackSiteModal';

interface PackSiteProps {
  packsites: ProductionPackSiteProps,
}

function PackSiteData({
  packsites,
}:PackSiteProps) { 
  // Ref
  const resolvePopover = useRef<HTMLLIElement>(null);
  // ModalState
  const initialModalState = {
    active: false,
  }
  const [modalState, setModalState] = useSetState(initialModalState);
  // State
  const defaultState = useMemo(() => ({
    expandEvent: false,
    popover: false,
  }), []);
  const [state, setState] = useSetState(defaultState);
  const handleClickOutside = useCallback((e: MouseEvent) => {
    if (e.target instanceof Element) {
      if (state.popover && resolvePopover.current && resolvePopover.current.contains(e.target)) {
        return;
      }
    }
    setState({ popover: false });
  }, [setState, state.popover]);


  function renderCellData(cell:{ label: string, value: string | number }) {
    return (
      <ListCell
        key={cell.label}
        label={cell.label}
        value={cell.value}
        responsive="1280"
      />
    );
  }

  useEffect(() => {
    if (state.popover) {
      document.addEventListener('mousedown', handleClickOutside);
    } else {
      document.removeEventListener('mousedown', handleClickOutside);
    }
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [handleClickOutside, state.popover]);

  useEffect(() => {
    setState(defaultState);
  }, [packsites, defaultState, setState])

  return (
    <>
      <div className={styles.container}>
        <div className={styles.main}>
          <div className={styles.badgeDetails}>
            <h3 className="subtitle1">
              {packsites.supplierId}
            </h3>
            <p className="body2">{packsites.manufacturingCompany}</p>
          </div>
          <div className={styles.details}>
            <h3 className="subtitle1">
              {packsites.itemDescription === 'All' ? 'All items' : packsites.itemDescription}
            </h3>
            <p className="body2">{ moment(packsites.ruleFromDate).format('DD MMM YYYY') } { packsites.ruleToDate ? 'to' : '' } { packsites.ruleToDate ? moment(packsites.ruleToDate).format('DD MMM YYYY') : '' }</p>
          </div>
          <ul className={styles.actions}>
            <li>
              <Button
                btnSize="small"
                btnType="icon"
                elevation="2-4"
                handler={() => setModalState({
                  active: true,
                })}
              >
                <Icon
                  icon="Edit"
                  fill="black"
                />
              </Button>
            </li>
          </ul>
          <div className={styles.cells}>
            { getPackSiteCellData(packsites).map(renderCellData)}
          </div>
        </div>
      </div>
      <PackSiteModal
        active={modalState.active}
        handleCancel={() => setModalState(initialModalState)}
        packSites={packsites}
      />
    </>
  );
}

export default PackSiteData;

